import { render, staticRenderFns } from "./GlMemHistory.vue?vue&type=template&id=208682fb&scoped=true"
import script from "./GlMemHistory.vue?vue&type=script&lang=js"
export * from "./GlMemHistory.vue?vue&type=script&lang=js"
import style0 from "./GlMemHistory.vue?vue&type=style&index=0&id=208682fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208682fb",
  null
  
)

export default component.exports